import { module } from 'angular';

import { Filter } from './';
import { Custom, default as customName } from './custom.component.ajs';

export default module('hypervision.skill-view.custom', [Filter]).component(customName, new Custom()).name;
